import _ from 'lodash';
import apiService from './ApiService';
class TokenService {
  constructor() {
    this.accessToken = 'access_token';
  }

  setToken = token => {
    const time = new Date().getTime();
    // Set Expire For 20 Hour
    const expires = time + 20 * 3600 * 1000;
    const value = {
      token,
      expires,
    };
    const convert = JSON.stringify(value);
    sessionStorage.setItem(this.accessToken, convert);
  };

  // SCRIPT INJECT TOKEN
  // setToken = token => {
  //   const time = new Date().getTime();
  //   // Set Expire For 20 Hour
  //   const expires = time + 20 * 3600 * 1000;
  //   const value = {
  //     token,
  //     expires,
  //   };
  //   const convert = JSON.stringify(value);
  //   sessionStorage.setItem('access_token', convert);
  // };

  getAccessToken = () => {
    const nowTime = new Date().getTime();
    const token = JSON.parse(sessionStorage.getItem(this.accessToken));
    const expires = _.get(token, 'expires', 0);
    // Check Is Toke Expire
    if (nowTime < expires) {
      // not expire
      return token.token;
    }
    return false;
  };

  removeAccessToken = () => {
    sessionStorage.removeItem(this.accessToken);
  };

  setAuthorize = () => {
    if (this.getAccessToken) {
      apiService.getInstance().setBearer(this.getAccessToken);
    }
  };
}

export default new TokenService();
